<div class="dialog-header">
  <h2 mat-dialog-title>Добавить лимиты квот</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ПИН</mat-label>
      <input matInput [(ngModel)]="personIdnp" name="personIdnp">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ИНН организации</mat-label>
      <input matInput [(ngModel)]="organizationInn" name="organizationInn">
    </mat-form-field>

    <div class="limits-section">
      <p class="section-title">Лимиты квот (в тоннах):</p>

      @if (loadingMeatTypes()) {
        <div class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Загрузка типов мяса...</p>
        </div>
      } @else {
        <div class="limits-form">
          @for (limit of quotaLimits(); track limit.meatType.id) {
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ getMeatTypeName(limit.meatType) }}</mat-label>
              <input matInput type="number"
                     [(ngModel)]="limit.totalLimitVolume"
                     [name]="'limit_' + limit.meatType.id"
                     min="0"
                     placeholder="0">
              <span matTextSuffix class="suffix-text">тонн</span>
            </mat-form-field>
          }
        </div>
      }
    </div>
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Отмена</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Подписать и сохранить
    }
  </button>
</mat-dialog-actions>
